import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor( private _authservice: ApiService, private route: ActivatedRoute, private _router : Router ) { } 
  canActivate() :boolean {
    if( this._authservice.loggedIn()){
    return true
    }else
    {
      
      let qac = window.location.pathname;
      this._router.navigate(['auth'+qac])
      return false;
    }
  } 
  
}
